<template>
  <div class="sidebar">
    <div class="logo">
      <span v-if="sidebarOpened">爱的小窝</span>
      <span v-else>爱</span>
    </div>
    <el-menu
      :default-active="activeMenu"
      :collapse="!sidebarOpened"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      router
    >
      <template v-for="route in routes">
        <el-submenu
          v-if="route.children && route.children.length > 1"
          :key="route.path"
          :index="route.path"
        >
          <template slot="title">
            <i :class="route.meta && route.meta.icon"></i>
            <span>{{ route.meta && route.meta.title }}</span>
          </template>
          <el-menu-item
            v-for="child in route.children"
            :key="route.path + '/' + child.path"
            :index="resolvePath(route.path, child.path)"
          >
            <i :class="child.meta && child.meta.icon"></i>
            <span slot="title">{{ child.meta && child.meta.title }}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item
          v-else-if="route.children && route.children.length === 1"
          :key="route.path"
          :index="resolvePath(route.path, route.children[0].path)"
        >
          <i :class="(route.children[0].meta && route.children[0].meta.icon) || (route.meta && route.meta.icon)"></i>
          <span slot="title">{{ (route.children[0].meta && route.children[0].meta.title) || (route.meta && route.meta.title) }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { constantRoutes } from '@/router'

export default {
  name: 'Sidebar',
  computed: {
    ...mapGetters(['sidebarOpened']),
    routes() { return constantRoutes.filter(r => !r.hidden) },
    activeMenu() { return this.$route.path }
  },
  methods: {
    resolvePath(base, child) {
      if (child.startsWith('/')) return child
      if (base === '/') return '/' + child
      return base + '/' + child
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.logo {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  background: #2b2f3a;
  overflow: hidden;
  white-space: nowrap;
}
.el-menu {
  border-right: none;
  flex: 1;
}
</style>
